export const getDefaultName = (polygonsLength: number, polygonType: string) => {
	return polygonsLength < 9
		? `${polygonType}_00${polygonsLength + 1}`
		: polygonsLength < 99
			? `${polygonType}_0${polygonsLength + 1}`
			: `${polygonType}_${polygonsLength + 1}`;
};
